import IconButton from '@mui/material/IconButton';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';

function Logout() {
    const navigate = useNavigate();
    const onLogout = () => {
        localStorage.clear();
        navigate('/login');
    };

    return (
        <IconButton onClick={onLogout}>
            <LogoutIcon />
        </IconButton>
    );
}

export default Logout;
